var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":"24","height":"24","viewBox":"0 0 24 24","fill":"currentColor"}},[_c('path',{attrs:{"d":"M4 6v13h16V6H4m14 11H6V8h12v9z"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }